var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-dialog',{ref:"dialog",attrs:{"title":"打印机设置","width":"1000","height":"600"}})
}
var staticRenderFns = []

export { render, staticRenderFns }